
import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import RL1SlipImportXmlLayout from "../../../components/RL1Slip/RL1SlipImportXmlLayout/RL1SlipImportXmlLayout";

export interface IRL1SlipImportXmlPage {}

export const RL1SlipImportXmlPage: FC<IRL1SlipImportXmlPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Import XML RL-1 Slip"
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Compliance", navigateTo: "/compliance/rl1/list" },
        { text: "RL-1", navigateTo: "/compliance/rl1/list" },
        { text: "Import XML RL-1 Slips", navigateTo: "/compliance/rl1/import-xml" },
      ]}
      mainContents={<RL1SlipImportXmlLayout />}
    />
  );
};
